import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  Output
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { finalize, take } from 'rxjs/operators';

import { ApiError, MessageService } from '../../../../core';
import { condicaoPagamentoAtiva } from '../../../../home/condicao-pagamento/condicao-pagamento-situacao';
import { CondicaoPagamentoFilter } from '../../../../home/condicao-pagamento/filter';
import { CondicaoPagamentoCrudHttpService } from '../../../../home/condicao-pagamento/services';
import { CustomControlValueAccessor } from '../../utils/custom-control-value-accessor/custom-control-value-accessor';
import { IMultiSelectSettings } from '../multi-select/models/multi-select-settings.interface';
import { IOption } from '../multi-select/models/option.interface';

@Component({
  selector: 'sgt-novo-condicao-pagamento-multiselect',
  templateUrl: './novo-condicao-pagamento-multiselect.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NovoCondicaoPagamentoMultiselectComponent),
      multi: true
    }
  ]
})
export class NovoCondicaoPagamentoMultiselectComponent extends CustomControlValueAccessor<number[]> {
  @Input() idsCondicoesPagamentos: number[];
  @Input() somenteAtivas = true;
  @Output() idsCondicoesPagamentosChange = new EventEmitter<number[]>();

  settings: IMultiSelectSettings = {
    placeholder: 'Selecione as condições de pagamento',
    plural: 'Condições de Pagamento',
    singular: 'Condição de Pagamento',
    searchEmptyResultMessage: 'Nenhuma condição de pagamento encontrada',
    showFooter: false
  };

  options: IOption[] = [];

  constructor(
    private messageService: MessageService,
    private condicaoPagamentoCrudHttpService: CondicaoPagamentoCrudHttpService
  ) {
    super();
  }

  firstOpened(isFirstOpened: boolean): void {
    if (isFirstOpened && this.options.length === 0) {
      this.create();
    }
  }

  private create() {
    const filter = new CondicaoPagamentoFilter();
    if (this.somenteAtivas) {
      filter.situacao = condicaoPagamentoAtiva.id;
    }

    this.definirCarregando(true);

    this.condicaoPagamentoCrudHttpService
      .searchWithFilter(filter)
      .pipe(take(1), finalize(() => this.definirCarregando(false)))
      .subscribe(
        (condicoesPagamentos) => {
          if (condicoesPagamentos && condicoesPagamentos.length > 0) {
            const currentIds = this.value ?? [];
            this.options = condicoesPagamentos.map((entity) => ({
              id: entity.id,
              label: entity.nome,
              isChecked: currentIds.includes(entity.id)
            }));
          }
        },
        (error: ApiError) => {
          this.messageService.error(
            error.message,
            'Erro ao pesquisar as condições de pagamentos',
            error
          );
        }
      );
  }

  protected updateValue(newValue: number[] | null): void {
    const ids = newValue ?? [];
    if (ids.length > 0 && this.options.length === 0) {
      this.create();
      return;
    }
    if (this.options.length > 0) {
      this.options.forEach((o) => {
        o.isChecked = ids.includes(o.id);
      });
    }
  }

  onSearch() {
    this.idsCondicoesPagamentosChange.emit(this.value);
  }

  onSelectionChange() {
    this.emitChange(this.idsCondicoesPagamentos);
    this.markAsTouched();
  }

  private definirCarregando(carregando: boolean): void {
    this.settings = { ...this.settings, isLoading: carregando };
  }

}
